import { BudgetView } from "../views/BudgetView";
import { DomainLayout } from "@/components/layouts/DomainLayout";

export const BudgetPage = () => {
    return (
        <DomainLayout>
            <BudgetView />
        </DomainLayout>
    )
}
